import { render, staticRenderFns } from "./MyInput.vue?vue&type=template&id=195ca8ab&scoped=true&"
import script from "./MyInput.vue?vue&type=script&lang=js&"
export * from "./MyInput.vue?vue&type=script&lang=js&"
import style0 from "./MyInput.vue?vue&type=style&index=0&id=195ca8ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ca8ab",
  null
  
)

export default component.exports